class PolyfillDeprecationWarning extends Error {
	/**
	 *
	 * @param polyfillTarget {string} the name of the method, property or function whose polyfill or monkey patch has been deprecated
	 * @param replacement {string} replacement suggestion to use instead of the existing code
	 */
	constructor(polyfillTarget, replacement) {
		super(`"${polyfillTarget}" is not a native method and the polyfill/monkeypatch for it has been deprecated and can be removed any time, use "${replacement}" instead.`);
		this.polyfillTarget = polyfillTarget;
		this.replacement = replacement;
	}

	/**
	 * Custom attributes to send to NewRelic
	 * @return {{replacementSuggestion: string, polyfillWarningFor: string}}
	 */
	get attributes() {
		return {
			polyfillWarningFor: this.polyfillTarget,
			replacementSuggestion: this.replacement
		};
	}
}

if (typeof window.HTMLCollection.prototype.forEach === 'undefined') {
	window.HTMLCollection.prototype.forEach = function (...args) {
		const error = new PolyfillDeprecationWarning('<HTMLCollection>.forEach', 'Array.from(<HTMLCollection>).forEach');
		console.warn(error, error.attributes)
		if (typeof globalThis.NREUM !== 'undefined') {
			NREUM.noticeError(error, error.attributes);
		}
		Array.prototype.forEach.call(this, ...args)
	}
}
